module.exports = __webpack_public_path__ + "static/img/设计师3.ad424a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师3.png
// module id = ikYP
// module chunks = 1